import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../api/msal";

export class MsalInitializationService {
  private static instance: PublicClientApplication | null = null;
  private static isInitializing = false;

  static async getInstance(): Promise<PublicClientApplication> {
    if (this.instance) {
      return this.instance;
    }

    if (this.isInitializing) {
      return new Promise((resolve) => {
        const checkInstance = () => {
          if (this.instance) {
            resolve(this.instance);
          } else {
            setTimeout(checkInstance, 50);
          }
        };
        checkInstance();
      });
    }

    this.isInitializing = true;

    try {
      this.validateEnvironment();
      const msalInstance = new PublicClientApplication(msalConfig);
      await msalInstance.initialize();

      this.instance = msalInstance;
      console.log("[MSAL] Instance initialized successfully");

      return msalInstance;
    } catch (error) {
      console.error("[MSAL] Initialization failed:", error);
      throw new Error(
        `Failed to initialize MSAL: ${error instanceof Error ? error.message : "Unknown error"}`,
      );
    } finally {
      this.isInitializing = false;
    }
  }

  private static validateEnvironment(): void {
    const requiredEnvVars = ["VITE_AZURE_CLIENT_ID", "VITE_AZURE_TENANT"];

    const missingVars = requiredEnvVars.filter(
      (varName) => !import.meta.env[varName],
    );

    if (missingVars.length > 0) {
      throw new Error(
        `Missing required environment variables: ${missingVars.join(", ")}`,
      );
    }

    // Validate client ID format (basic UUID check)
    const clientId = import.meta.env.VITE_AZURE_CLIENT_ID;
    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    if (!uuidRegex.test(clientId)) {
      console.warn(
        "[MSAL] Client ID does not appear to be a valid UUID format",
      );
    }
  }
}
